import { Component } from '@angular/core';

@Component({
    selector: 'cmps-event-centre-card-stripe',
    template: '<ng-content></ng-content>',
    host: {
        class: 'cmps-event-centre-card-stripe',
    },
})
export class CardStripeComponent {}
